import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Quiz submitted", { props: { triggerType: "Form Submitted", event: "Quiz / scorecard" } }],
  ["f1s", "auto-field", "Store the score", { props: { field: "quiz_score", op: "set" } }],
  ["c1", "auto-condition", "Score 0-3 — beginner?", { props: { condition: "quiz_score is less than 4" } }],
  ["g1", "auto-tag-add", "Tag: beginner", { props: { tag: "segment-beginner" } }],
  ["e1", "auto-email", "Your result + the beginner plan", { props: { subject: "Your score: {{contact.quiz_score}}/10 — start here" } }],
  ["c2", "auto-condition", "Score 8+ — sales ready?", { props: { condition: "quiz_score is greater than 7" } }],
  ["g2", "auto-tag-add", "Tag: sales-ready", { props: { tag: "segment-sales-ready" } }],
  ["nt", "auto-notify", "Ping sales on high scorers", { props: { channel: "email", message: "{{contact.full_name}} scored {{contact.quiz_score}}/10" } }],
]);

const def: TemplateDef = {
  slug: "quiz-funnel-segmentation",
  name: "Quiz Funnel + Segmentation",
  category: "Lead gen",
  tagline:
    "One quiz, three audiences — score the answers and send each segment a different email.",
  description:
    "A free quiz funnel template: a scored quiz captures the lead, the score lands on a contact field, and If/Else branches tag beginners, middles and sales-ready leads so each gets the email that fits. Clone it into FrazzleCRM and the segmentation runs itself.",
  whatsInside: [
    "Quiz / scorecard page wired to a form-submitted trigger",
    "Score written to a contact field you can filter and report on",
    "Two branches that split the list into beginner, middle and sales-ready",
    "An internal alert so sales only sees the people who scored high",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-tiktok", "TikTok", 40, 60),
      node("src2", "traffic-facebook", "Facebook Ads", 40, 220, { props: { campaign: "Quiz — cold" } }),
      node("qz", "page-survey", "The quiz", 360, 140, { props: { questions: "7" } }),
      node("ty", "page-thankyou", "Your result", 680, 140),
      flow("f1", "Score & Segment", 1000, 40, 420, 856),
      ...seq.nodes,
      node("sp", "page-sales", "Offer matched to the score", 1520, 340, { props: { price: "$297" } }),
      node("n1", "util-note", "Why a quiz outperforms a PDF", 680, 340, {
        notes:
          "A quiz earns the answer BEFORE the pitch: people tell you their situation to see their result. That is segmentation data no lead magnet gives you, collected while attention is highest.",
      }),
    ],
    [
      edge("src1", "qz"),
      edge("src2", "qz"),
      edge("qz", "ty"),
      edge("ty", "f1"),
      ...seq.edges,
      edge("f1", "sp"),
    ]
  ),
};

export default def;
